export default [
	{
		path: '/order/list',
		name: 'order-list',
		meta: { title: '订单管理', hidden: false },
		component: () => import('@/views/order/orders/OrderList.vue')
	},
	{
		path: '/entry/list',
		name: 'entry-list',
		meta: { title: '采购单管理', hidden: false },
		component: () => import('@/views/order/entry/EntryWordList.vue')
	},
	{
		path: '/sorting/list',
		name: 'sorting-list',
		meta: { title: '分拣单管理', hidden: false },
		component: () => import('@/views/order/sorting/SortingList.vue')
	},
	{
		path: '/delivery/list',
		name: 'delivery-list',
		meta: { title: '发货单管理', hidden: false },
		component: () => import('@/views/order/delivery/DeliveryList.vue')
	},
	{
		path: '/entry/stock',
		name: 'entry-stock',
		meta: { title: '库存管理', hidden: false },
		component: () => import('@/views/order/entry/StockList.vue')
	}
]